const c = (l) => {
  const t = `${l}=`, n = document.cookie.split(";");
  for (let o = 0; o < n.length; o++) {
    let e = n[o];
    for (; e.charAt(0) === " "; )
      e = e.substring(1);
    if (e.indexOf(t) === 0)
      return e.substring(t.length, e.length);
  }
  return "";
}, r = (l) => {
  let t = null;
  const n = l ? c(l) : null;
  if (n) {
    t = {};
    const o = n.split("&");
    for (let e = 0; e < o.length; e++) {
      const s = o[e].split("="), i = s[0];
      if (i) {
        const u = s[1];
        t[i] = u;
      }
    }
  }
  return t;
}, a = () => ({
  getObjectCookie: r
});
export {
  a as default
};
//# sourceMappingURL=useCookie-es.js.map
